import JackocoinsNetworkManagerMixin from "@/mixins/JackocoinsNetworkMangerMixin";
import { IAccount } from "@/modules/auth/types";
import { EServices } from "@/types";
import { throwsNetworkError } from "@/utils/http/NetworkManagerMixin";
import { Component, Inject, Mixins, Ref, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import ReferralsClient from "../../services/ReferralsClient";
import { IDownliner, IEarnings, IReferral, IReferrals } from "../../types";
import VScrollView from "@/vuetify-extensions/VScrollView.vue";

// const ReferralModule = namespace("ReferralModule");
const AccountModule = namespace("AccountModule");

@Component({
  components: {
    VScrollView,
  },
})
export default class Referrals extends Mixins(JackocoinsNetworkManagerMixin) {
  tab = null;
  tabTitle: string[] = ["my Gang", "my Squad(Downlines)"];
  referrals: IReferrals[] = [];
  downliners: IDownliner[] = [];
  tradeInfo: IEarnings | null = null;
  refresh = false;

  referralInfo: IReferrals | null = null;

  get referralCode() {
    return this.referralInfo!.referralCode;
  }

  get referralLink() {
    return "https://app.jackocoins.com/register?referral=" + this.referralCode;
  }

  get totalReferred() {
    return this.tradeInfo ? this.tradeInfo.totalReferred : 0;
  }

  get totalNoOfTrade() {
    return this.tradeInfo ? this.tradeInfo.totalTradeCount : 0;
  }
  get totalUsdTrade() {
    return this.tradeInfo ? this.tradeInfo.totalTradeUSD : 0;
  }

  @throwsNetworkError()
  async gettotalTrade() {
    const { data } = await this.referralsClient.totalReferralTrade();
    this.tradeInfo = data;
    return data;
  }

  @AccountModule.State
  account!: IAccount;

  @Inject(EServices.referrals)
  referralsClient!: ReferralsClient;

  @Ref()
  copyPasteReferralCode!: HTMLInputElement;

  @Ref()
  copyPasteReferralUrl!: HTMLInputElement;

  copyReferralCode() {
    this.copyPasteReferralCode.select();
    this.copyPasteReferralCode.setSelectionRange(
      0,
      this.copyPasteReferralCode.value.length
    );
    document.execCommand("copy");
    toast({
      icon: "mdi-check",
      message: "Referral Code Copied!",
      iconColor: "green",
    });
  }

  copyReferralUrl() {
    this.copyPasteReferralUrl.select();
    this.copyPasteReferralUrl.setSelectionRange(
      0,
      this.copyPasteReferralUrl.value.length
    );
    document.execCommand("copy");
    toast({
      icon: "mdi-check",
      message: "Referral Link Copied!",
      iconColor: "green",
    });
  }

  @throwsNetworkError()
  async getReferral() {
    const response = await this.referralsClient.fetchReferral(this.account.id);
    return (this.referralInfo = response.data);
  }

  @throwsNetworkError()
  async getDownliners(page: number = 1, size: number = 2) {
    const payload = {
      page,
      size,
    };
    const response = await this.referralsClient.fetchAllUserDownliners(payload);
    return response;
  }

  @throwsNetworkError()
  async getListOfReferrals(page: number = 1, size: number = 2) {
    const payload = {
      page,
      size,
    };
    const response = await this.referralsClient.fetchAllUserReferrals(payload);
    return response;
  }

  @Watch("error.getReferral")
  onError(message: string) {
    if (message)
      toast({ icon: "mdi-exclamation-thick", iconColor: "red", message });
  }

  async mounted() {
    await this.getReferral();
    this.gettotalTrade();
  }
}
